import React from 'react'
import styles from "../myprofile/myprofile.module.css"
import ProfileMenu from '../../Components/profilemenu/ProfileMenu'
import Orderscomp from '../../Components/orderscomp/Orderscomp'
import Myprofile from '../myprofile/Myprofile'
import { useLocation } from 'react-router-dom'

const OrderDetails = () => {
    const location = useLocation()
    const tab = location.state
  
    
    return (
        <>
             <Myprofile>
             
                <Orderscomp tab={tab}/>
            </Myprofile>
        </>
    )
}

export default OrderDetails